import * as React from 'react';

import { useReviews } from 'hooks/review/useReviews';

import { TReview } from 'types/review';

export const sortByDescRating = (a: TReview, b: TReview) =>
  a.rating > b.rating ? -1 : 1;

export const MAX_REVIEWS = 5;

type Props = {
  maxCount?: number;
};

export const useReviewsCarousel = ({ maxCount: MAX_REVIEWS }: Props = {}) => {
  const { reviews, showReviews } = useReviews();

  const aboutLink = '/about#reviews';

  const [currentReviewIndex, setCurrentReviewIndex] = React.useState(0);
  const reviewsList = reviews.sort(sortByDescRating).slice(0, MAX_REVIEWS);

  const setNextReviewIndex = () => {
    let nextIndex = currentReviewIndex + 1;

    if (currentReviewIndex === reviewsList.length - 1) {
      nextIndex = 0;
    }

    setCurrentReviewIndex(nextIndex);
  };

  const setPrevReviewIndex = () => {
    let nextIndex = currentReviewIndex - 1;

    if (currentReviewIndex === 0) {
      nextIndex = reviewsList.length - 1;
    }

    setCurrentReviewIndex(nextIndex);
  };

  return {
    aboutLink,
    currentReviewIndex,
    reviews: reviewsList,
    showNextReview: setNextReviewIndex,
    showPrevReview: setPrevReviewIndex,
    showReviews,
  };
};
